import { PortableTextMarkComponent } from '@portabletext/react'
import React from 'react'

export const ColoredTextSerializer: PortableTextMarkComponent = ({ children }) => (
  <span className="text-secondary-dark font-t-light text-t-200">{children}</span>
)
